import axiosInstance from "@/lib/axios";

export const reportService = {
  // Récupérer la liste paginée des signalements (modération)
  getReports: async (params = {}) => {
    const response = await axiosInstance.get('/api/v1/admin/reports', { params });
    return response.data;
  },

  // Détail d'un signalement
  getReport: async (id) => {
    const response = await axiosInstance.get(`/api/v1/admin/reports/${id}`);
    return response.data;
  },

  // Marquer un signalement comme lu
  markAsRead: async (id) => {
    const response = await axiosInstance.post(`/api/v1/admin/reports/${id}/read`);
    return response.data;
  },

  // Nombre de signalements non encore lus (badge sidebar)
  getUnreadCount: async () => {
    const response = await axiosInstance.get('/api/v1/admin/reports/unread-count');
    return response.data;
  },
};
